<div class="ethos-import-logs-dialog">
  <h2 mat-dialog-title>Ethos Import Logs</h2>
  
  <mat-dialog-content>
    <!-- Current Status Banner -->
    <div *ngIf="currentStatus?.status === 'running'" class="current-status-banner">
      <mat-icon class="spinning">sync</mat-icon>
      <span>Import in progress - Started {{ formatDate(currentStatus.startTime) }}</span>
      <div class="progress-info">
        <span>{{ currentStatus.processedVehicles }} / {{ currentStatus.totalVehicles }} vehicles processed</span>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Data Table -->
    <div *ngIf="!loading" class="table-container">
      <div class="table-wrapper" [class.has-data]="dataSource.data.length > 0">
        <table mat-table [dataSource]="dataSource" matSort *ngIf="dataSource.data.length > 0">
          <!-- Start Time Column -->
          <ng-container matColumnDef="startTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</th>
            <td mat-cell *matCellDef="let log">{{ formatDate(log.startTime) }}</td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let log">
              <div class="status-cell" [ngClass]="getStatusClass(log.status)">
                <mat-icon>{{ getStatusIcon(log.status) }}</mat-icon>
                <span>{{ log.status | titlecase }}</span>
              </div>
            </td>
          </ng-container>

          <!-- Trigger Type Column -->
          <ng-container matColumnDef="triggerType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Trigger</th>
            <td mat-cell *matCellDef="let log">{{ log.triggerType | titlecase }}</td>
          </ng-container>

          <!-- Total Vehicles Column -->
          <ng-container matColumnDef="totalVehicles">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total</th>
            <td mat-cell *matCellDef="let log">{{ log.totalVehicles }}</td>
          </ng-container>

          <!-- Processed Vehicles Column -->
          <ng-container matColumnDef="processedVehicles">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Processed</th>
            <td mat-cell *matCellDef="let log">{{ log.processedVehicles }}</td>
          </ng-container>

          <!-- Skipped Vehicles Column -->
          <ng-container matColumnDef="skippedVehicles">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Skipped</th>
            <td mat-cell *matCellDef="let log">{{ log.skippedVehicles }}</td>
          </ng-container>

          <!-- Error Count Column -->
          <ng-container matColumnDef="errorCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Errors</th>
            <td mat-cell *matCellDef="let log">
              <span [class.error-count]="log.errorCount > 0">{{ log.errorCount }}</span>
            </td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef>Duration</th>
            <td mat-cell *matCellDef="let log">{{ log.duration || '-' }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
              (click)="expandRow(row)"
              class="clickable-row"></tr>
        </table>

        <!-- No Data Message -->
        <div *ngIf="dataSource.data.length === 0" class="no-data">
          <mat-icon>info</mat-icon>
          <p>No import logs found</p>
        </div>
      </div>

      <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button color="warn" (click)="clearLogs()" [disabled]="loading || dataSource.data.length === 0">
      <mat-icon>delete</mat-icon>
      Clear Logs
    </button>
    <button mat-button (click)="close()" style="margin-left: auto;">Close</button>
  </mat-dialog-actions>
</div>